<template>
  <div class="flex w-full items-center justify-between">
    <div v-if="!mainStore.previousStep" class="flex items-center">
      <span class="flex items-center rounded-full bg-success p-2">
        <fa-icon type="fas" icon="shield-check" class="text-xl text-white" />
      </span>
      <span class="ml-3 hidden text-success md:block">Simple, rapide et gratuit</span>
      <span class="ml-3 text-success md:hidden">Simple et rapide</span>
    </div>
    <button
      v-else
      id="fast-project-back"
      class="btn fast-step-back text-brand"
      type="button"
      tabindex="-1"
      @click="$emit('goToPrev')"
    >
      Retour
    </button>
    <button
      class="btn btn-primary !px-12 !py-2"
      :disabled="nextDisabled"
      :class="{ disabled: nextDisabled }"
      @click="$emit('goToNext')"
    >
      {{ nextBtnText }}
    </button>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'

export default {
  props: {
    nextDisabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapStores(useMainStore),
    nextBtnText() {
      return this.mainStore.step === STEPS.location ? "Valider l'annonce" : 'Continuer'
    }
  }
}
</script>
